import './util/polyfill';
import './util/jquery';
import './lib/bootstrap';
import './sc.module';
import './lib/splitter';

//import 'webpack/hot/dev-server';

require('./util/printing.scss');



// WEBPACK FOOTER //
// ./src/app.js